import { linkOptions } from '@tanstack/react-router';

import { Text } from '../cdl/Text/Text';
import { translate } from '../common/helpers/translate.helper';
import { useGroupContext } from '../common/hooks/useGroupContext';
import { useRole } from '../common/hooks/useRole';
import { IconBuildingSkyscraper } from '../common/icons/cdl/BuildingSkyscraper';
import { IconTerminal2 } from '../common/icons/cdl/Terminal2';
import { MenuItem } from '../common/MenuItem/MenuItem';
import { Box } from '../common/ui/Box';
import { isCustomerContextType } from '../common/utils/groupContextTypeUtils';
import { CustomerGroupTabs } from '../group/customer/CustomerGroupTabs';
import { SupplierGroupTabs } from '../group/supplier/SupplierGroupTabs';

export const SuperAdminGroupSettingsSection = () => {
    const role = useRole();
    const { groupId: contextGroupId, type: contextGroupType } = useGroupContext();

    if (!role.isSuperAdmin() || !contextGroupId || !contextGroupType) {
        return null;
    }

    return (
        <Box display="flex" flexDirection="column" gap={16}>
            <Text variant="subtitle1">{translate('settings.groupSettings.title')}</Text>
            <Box display="grid" gridTemplateColumns="repeat(auto-fit, minmax(348px, 348px))" columnGap={48} rowGap={16}>
                <MenuItem
                    title={translate('settings.groupManagement.title')}
                    description={translate('settings.groupManagement.description')}
                    Icon={IconBuildingSkyscraper}
                    linkOptions={linkOptions({
                        to: isCustomerContextType(contextGroupType)
                            ? '/customer-groups/$groupId'
                            : '/supplier-groups/$groupId',
                        params: { groupId: contextGroupId },
                    })}
                />

                <MenuItem
                    title={translate('settings.companyManagement.title')}
                    description={translate('settings.companyManagement.description')}
                    Icon={IconBuildingSkyscraper}
                    linkOptions={linkOptions({
                        to: isCustomerContextType(contextGroupType)
                            ? '/customer-groups/$groupId/companies'
                            : '/supplier-groups/$groupId/companies',
                        params: { groupId: contextGroupId },
                    })}
                />

                <MenuItem
                    title={translate('settings.developers.title')}
                    description={translate(
                        isCustomerContextType(contextGroupType)
                            ? 'settings.developers.customers.description'
                            : 'settings.developers.suppliers.description'
                    )}
                    Icon={IconTerminal2}
                    linkOptions={linkOptions({
                        to: isCustomerContextType(contextGroupType)
                            ? '/customer-groups/$groupId'
                            : '/supplier-groups/$groupId',
                        params: { groupId: contextGroupId },
                        search: {
                            tab: isCustomerContextType(contextGroupType)
                                ? CustomerGroupTabs.DEVELOPERS
                                : SupplierGroupTabs.DEVELOPERS,
                        },
                    })}
                />
            </Box>
        </Box>
    );
};
